import { render, staticRenderFns } from "./faq-page.vue?vue&type=template&id=06640876&"
import script from "./faq-page.vue?vue&type=script&lang=js&"
export * from "./faq-page.vue?vue&type=script&lang=js&"
import style0 from "./faq-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports